import { uuid } from '@wix/answers-lib';
import {EventType} from '../event-type';
import {ArticleType} from '@wix/answers-api';
import { getAnonId } from '@wix/answers-bi';

export const createWixEventHandler  = (source: string, locale: string) => {
	let referralUrl = document.referrer;
	let userId: string;
	let clientId: string;
	try {
		const matchUserId = /[?&]user_id=([^&]*)/.exec(window.location.search);
		if (matchUserId) {
			userId = matchUserId[1];
		}
		const matchClientId = getAnonId() || uuid();

		if (matchClientId) {
			clientId = matchClientId;
		}
		else {
			clientId = uuid();
		}

	} catch (e) {
		// Do nothing
	}

	const callBI = (url: string) => {
		try {
		const image = new Image();
		image.src = url;
		} catch (e) {
			// So what..
		}
	};

	const logEvent = (eventId: number, eventData: any) => {

		const query: string[] = [];
		query.push('evid=' + eventId);
		query.push('src=4');
		query.push('lang=' + locale);
		query.push('source_name=' + source);
		query.push('_=' + new Date().getTime());

		if (userId) {
			query.push('uuid=' + userId);
		}
		else {
			query.push('client_id=' + clientId);
		}

		if (eventData) {
			Object.keys(eventData).forEach((key: string) => {
				query.push(key + '=' + encodeURIComponent(eventData[key]));
			});
		}

		const url = `${window.location.protocol}//frog.wix.com/ans_bi?${query.join('&')}`;

		callBI(url);
	};

	return (event: EventType, data: any) => {
		const actionDate = new Date().toISOString();
		const referrer = document.referrer;
		const capturedReferral = /referral=([^&]+)/.exec(referrer);
		const referralName = capturedReferral && capturedReferral[1] ? capturedReferral[1] : undefined;

		switch (event) {
			case EventType.LOAD:
				logEvent(559, {
					item_url: window.location.href,
					client_name: source,
					referral_name: referralUrl,
					ts: -1
				});
				referralUrl = window.location.href;
				break;
			case EventType.KB_HOME_VIEW:
				logEvent(531, {
					item_url: window.location.href,
					item_name: 'kb_home',
					referral_url: referralUrl
				});
				referralUrl = window.location.href;
				break;
			case EventType.CONTACT_VIEW:
				logEvent(531, {
					item_url: window.location.href,
					item_name: 'contact',
					referral_url: referralUrl
				});
				referralUrl = window.location.href;
				break;
			case EventType.ARTICLE_VIEW:
				logEvent(531, {
					item_url: window.location.href,
					item_id: data.articleId,
					item_name: data.articleTitle,
					referral_url: referralUrl
				});
				referralUrl = window.location.href;
				break;
			case EventType.CATEGORY_VIEW:
				logEvent(531, {
					item_url: window.location.href,
					item_id: data.categoryId,
					item_name: data.categoryTitle,
					referral_url: referralUrl
				});
				referralUrl = window.location.href;
				break;
			case EventType.ARTICLE_NOT_FOUND:
				logEvent(531, {item_url: '404_' + window.location.href});
				break;
			case EventType.SEARCH:
				logEvent(520, {
					question: data.term,
					first_answer: data.firstAnswer,
					source_url: window.location.href,
					action_date: actionDate
				});
				break;
			case EventType.SEARCH_NO_RESULT:
				logEvent(537, {
					question: data.term,
					source_url: window.location.href,
				});
				break;
			case EventType.SEARCH_RESULT_CLICK:
				logEvent(521, {
					question: data.term,
					answer: data.articleTitle,
					order: data.position + 1,
					action_date: actionDate,
					item_url: data.articleUri,
					source_url: window.location.href
				});
				break;
			case EventType.ARTICLE_VOTE:
			case EventType.ARTICLE_UNVOTE:
			case EventType.ARTICLE_HELPFUL:
			case EventType.ARTICLE_UNHELPFUL:
				let eventId = 501;
				switch (data.article.type) {
					case ArticleType.ARTICLE:
						eventId = 501;
						break;
					case ArticleType.FEATURE_REQUEST:
						eventId = 502;
						break;
					case ArticleType.KNOWN_ISSUE:
						eventId = 503;
						break;
					default:
						break;
				}
				logEvent(eventId, {
					thumbs_up: data.vote,
					item_name: data.article.title,
					item_id: data.article.id,
					item_url: window.location.href,
					category: data.article.categoryId
				});
				break;
			case EventType.OPEN:
				logEvent(662, {
					open_method: data.openMethod,
					module_name: data.moduleName,
					referral_name: referralName,
					referral_url: referrer
				});
				break;
			case EventType.CLOSE:
				logEvent(663, {
					close_method: data.openMethod,
					module_name: data.moduleName,
					referral_name: referralName,
					referral_url: referrer
				});
				break;
			case EventType.CHAT_STARTED_SUCCESS:
				logEvent(664, {
					ticket_id: data.ticketId,
					referral_name: referralName,
					referral_url: referrer
				});
				break;
			default:
				break;
		}

		return Promise.resolve();
	};
};
